import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { FeedbackLink, Modal } from '@figure/frontlib-gui';
import { useFeedback } from 'shared/hooks';
import FeedbackForm from './FeedbackForm';

const FeedbackContainer = () => {
  const location = useLocation();
  const params = useParams();
  const [isOpen, setOpen] = useState(false);
  const { error: serverError, saveCeoFeedback, handleSubmit } = useFeedback();
  const applicationUuid = params.uuid || null;

  return (
    <>
      <FeedbackLink handleClick={() => setOpen(true)} />

      <Modal header="Share your thoughts with our CEO" size="sm" isOpen={isOpen} onClose={() => setOpen(false)}>
        <FeedbackForm
          handleSubmit={async (data) => {
            await saveCeoFeedback({
              ...data,
              applicationUuid, //: params.uuid
              pathname: location.pathname,
              productType: 'PL',
            });

            setOpen(false);
          }}
          serverError={serverError}
        />
      </Modal>
    </>
  );
};

export default FeedbackContainer;
